export default __webpack_public_path__ + "static/media/Long&Foster.368d0f70.jpg";